module.exports = __webpack_public_path__ + "static/media/loading_logo.a8f51fb6.png";